import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import advertisementImage from './assets/WhatsApp Image 2026-06-02 at 10.39.20.jpeg';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SEO from './components/SEO';
import Home from './pages/Home';
import Villa from './pages/Villa';
import ApartmentRooms from './pages/ApartmentRooms';
import ApartmentRoomsVilla from './pages/ApartmentRoomsVilla';
import AyurvedaSpa from './pages/AyurvedaSpa';
import AboutUs from './pages/AboutUs';
import Gallery from './pages/Gallery';
import ContactUs from './pages/ContactUs';
import Search from './pages/Booking/Search';
import Booking from './pages/Booking/Booking';
import Checkout from './pages/Booking/Checkout';
import Confirmation from './pages/Booking/Confirmation';
import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';
import AdminEvents from './components/Admin/AdminEvents';
import AdminPackages from './components/Admin/AdminPackages';
import Packages from './pages/Packages';
import AdminGallery from './components/Admin/AdminGallery';

function SiteAdvertisement() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const [isVisible, setIsVisible] = useState(() => !isAdminRoute);

  useEffect(() => {
    if (location.pathname === '/') {
      setIsVisible(true);
    } else if (isAdminRoute) {
      setIsVisible(false);
    }
  }, [isAdminRoute, location.pathname]);

  if (!isVisible || isAdminRoute) return null;

  return (
    <div className="site-ad-backdrop" role="presentation">
      <section
        className="site-ad-dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Resort advertisement"
      >
        <button
          className="site-ad-close"
          type="button"
          aria-label="Close advertisement"
          onClick={() => setIsVisible(false)}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <img src={advertisementImage} alt="Sun Flower Beach Resort advertisement" />
      </section>
    </div>
  );
}

function App() {
  const baseUrl = 'https://sunflower-resort.com';
  const baseKeywords =
    'beach resort, Sun Flower Beach Resort, Beruwala, Sri Lanka, Ayurveda wellness, spa, luxury accommodations, restaurant, fine dining, tropical vacation, relaxation, yoga, meditation, holistic healing, stress relief, detox, rejuvenation, ayurvedic treatments, panchakarma, abhyanga, herbal remedies, beachfront, coastal getaway, healthy lifestyle, organic dining, sustainable tourism, family vacation, couples retreat, wellness retreat, sri lanka resort, beruwala resort, luxury villa, beach holiday, nature escape';

  return (
    <Router>
      <div>
        <SiteAdvertisement />
        <Navbar />
        <div style={{ padding: '20px' }}>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <SEO
                    title="Sun Flower Beach Resort - Beruwala, Sri Lanka"
                    description="Discover relaxation and rejuvenation at Sun Flower Beach Resort in Beruwala, Sri Lanka. Enjoy luxurious accommodations, authentic Ayurvedic wellness treatments, gourmet dining, and serene beachfront experiences. Book your tropical escape today!"
                    keywords={baseKeywords}
                    url={`${baseUrl}/`}
                  />
                  <Home />
                </>
              }
            />
            <Route
              path="/villa"
              element={
                <>
                  <SEO
                    title="Resort | Sun Flower Beach Resort, Beruwala"
                    description="Explore luxurious accommodations at Sun Flower Beach Resort in Beruwala, Sri Lanka. Enjoy serene beachfront surroundings and exceptional comfort."
                    keywords={`resort, sunflower beach resort, beruwala resort, sri lanka resort, ${baseKeywords}`}
                    url={`${baseUrl}/villa`}
                  />
                  <Villa />
                </>
              }
            />
            <Route
              path="/deluxe-double-rooms"
              element={
                <>
                  <SEO
                    title="Deluxe Double Rooms | Sun Flower Beach Resort, Beruwala"
                    description="Discover comfortable Deluxe Double Rooms at Sun Flower Beach Resort in Beruwala, Sri Lanka, perfect for a relaxing coastal getaway."
                    keywords={`deluxe double rooms, sunflower beach resort rooms, beruwala accommodation, ${baseKeywords}`}
                    url={`${baseUrl}/deluxe-double-rooms`}
                  />
                  <ApartmentRooms />
                </>
              }
            />
            <Route
              path="/deluxe-double-room-sea-view"
              element={
                <>
                  <SEO
                    title="Deluxe Double Room with Sea View | Sun Flower Beach Resort, Beruwala"
                    description="Experience Deluxe Double Rooms with stunning sea views at Sun Flower Beach Resort in Beruwala, Sri Lanka, for a memorable beachfront stay."
                    keywords={`deluxe double room sea view, sunflower beach resort rooms, beruwala sea view, ${baseKeywords}`}
                    url={`${baseUrl}/deluxe-double-room-sea-view`}
                  />
                  <ApartmentRoomsVilla />
                </>
              }
            />
            <Route
              path="/ayurveda-spa"
              element={
                <>
                  <SEO
                    title="Ayurveda Wellness | Sun Flower Beach Resort, Beruwala"
                    description="Rejuvenate with authentic Ayurveda wellness treatments at Sun Flower Beach Resort in Beruwala, Sri Lanka, including holistic therapies and relaxation."
                    keywords={`ayurveda wellness, sunflower beach resort spa, beruwala wellness, panchakarma, ${baseKeywords}`}
                    url={`${baseUrl}/ayurveda-spa`}
                  />
                  <AyurvedaSpa />
                </>
              }
            />
            <Route
              path="/about-us"
              element={
                <>
                  <SEO
                    title="About Us | Sun Flower Beach Resort, Beruwala"
                    description="Learn about Sun Flower Beach Resort’s commitment to luxury, wellness, and sustainability in Beruwala, Sri Lanka."
                    keywords={`about sunflower beach resort, beruwala wellness, sri lanka resort, ${baseKeywords}`}
                    url={`${baseUrl}/about-us`}
                  />
                  <AboutUs />
                </>
              }
            />
            <Route
              path="/gallery"
              element={
                <>
                  <SEO
                    title="Gallery | Sun Flower Beach Resort, Beruwala"
                    description="Browse stunning photos of Sun Flower Beach Resort’s accommodations, Ayurveda wellness center, restaurant, and beachfront in Beruwala, Sri Lanka."
                    keywords={`sunflower beach resort gallery, beruwala resort photos, sri lanka beach images, ${baseKeywords}`}
                    url={`${baseUrl}/gallery`}
                  />
                  <Gallery />
                </>
              }
            />
            <Route
              path="/packages"
              element={
                <>
                  <SEO
                    title="Packages | Sun Flower Beach Resort, Beruwala"
                    description="Explore exclusive packages at Sun Flower Beach Resort in Beruwala, Sri Lanka, combining Ayurveda wellness, dining, and beachfront accommodations."
                    keywords={`sunflower beach resort packages, beruwala wellness deals, sri lanka resort offers, ${baseKeywords}`}
                    url={`${baseUrl}/packages`}
                  />
                  <Packages />
                </>
              }
            />
            <Route
              path="/contact-us"
              element={
                <>
                  <SEO
                    title="Contact Us | Sun Flower Beach Resort, Beruwala"
                    description="Get in touch with Sun Flower Beach Resort in Beruwala for bookings and inquiries about our resort, Ayurveda wellness, and dining experiences."
                    keywords={`contact sunflower beach resort, beruwala resort booking, sri lanka wellness inquiries, ${baseKeywords}`}
                    url={`${baseUrl}/contact-us`}
                  />
                  <ContactUs />
                </>
              }
            />
            <Route
              path="/booking"
              element={
                <>
                  <SEO
                    title="Book Your Stay | Sun Flower Beach Resort, Beruwala"
                    description="Book your resort stay or Ayurveda wellness package at Sun Flower Beach Resort in Beruwala with our easy online booking system."
                    keywords={`book sunflower beach resort, beruwala resort booking, ayurveda wellness package, ${baseKeywords}`}
                    url={`${baseUrl}/booking`}
                  />
                  <Search />
                </>
              }
            />
            <Route
              path="/booking/booking"
              element={
                <>
                  <SEO
                    title="Booking Details | Sun Flower Beach Resort, Beruwala"
                    description="Complete your booking at Sun Flower Beach Resort in Beruwala for a luxurious resort and wellness experience."
                    keywords={`sunflower beach resort booking, beruwala resort booking, sri lanka wellness booking, ${baseKeywords}`}
                    url={`${baseUrl}/booking/booking`}
                  />
                  <Booking />
                </>
              }
            />
            <Route
              path="/booking/checkout"
              element={
                <>
                  <SEO
                    title="Checkout | Sun Flower Beach Resort, Beruwala"
                    description="Securely complete your booking at Sun Flower Beach Resort in Beruwala with our simple checkout process."
                    keywords={`sunflower beach resort checkout, beruwala resort checkout, booking confirmation, ${baseKeywords}`}
                    url={`${baseUrl}/booking/checkout`}
                  />
                  <Checkout />
                </>
              }
            />
            <Route
              path="/booking/confirmation"
              element={
                <>
                  <SEO
                    title="Booking Confirmation | Sun Flower Beach Resort, Beruwala"
                    description="Your booking at Sun Flower Beach Resort in Beruwala is confirmed. We look forward to welcoming you!"
                    keywords={`sunflower beach resort confirmation, beruwala booking success, sri lanka resort reservation, ${baseKeywords}`}
                    url={`${baseUrl}/booking/confirmation`}
                  />
                  <Confirmation />
                </>
              }
            />
            <Route
              path="/admin/login"
              element={
                <>
                  <SEO
                    title="Admin Login | Sun Flower Beach Resort, Beruwala"
                    description="Admin login for Sun Flower Beach Resort’s management portal in Beruwala, Sri Lanka."
                    keywords={`admin login, sunflower beach resort admin, beruwala admin, ${baseKeywords}`}
                    url={`${baseUrl}/admin/login`}
                  />
                  <AdminLogin />
                </>
              }
            />
            <Route
              path="/admin/dashboard"
              element={
                <>
                  <SEO
                    title="Admin Dashboard | Sun Flower Beach Resort, Beruwala"
                    description="Manage events, packages, and gallery content for Sun Flower Beach Resort in Beruwala, Sri Lanka."
                    keywords={`admin dashboard, sunflower beach resort admin, beruwala admin, ${baseKeywords}`}
                    url={`${baseUrl}/admin/dashboard`}
                  />
                  <AdminDashboard />
                </>
              }
            />
            <Route
              path="/admin/events"
              element={
                <>
                  <SEO
                    title="Manage Events | Sun Flower Beach Resort, Beruwala"
                    description="Admin panel to manage events for Sun Flower Beach Resort in Beruwala, Sri Lanka."
                    keywords={`manage events, sunflower beach resort events, beruwala events, ${baseKeywords}`}
                    url={`${baseUrl}/admin/events`}
                  />
                  <AdminEvents />
                </>
              }
            />
            <Route
              path="/admin/packages"
              element={
                <>
                  <SEO
                    title="Manage Packages | Sun Flower Beach Resort, Beruwala"
                    description="Admin panel to manage packages for Sun Flower Beach Resort in Beruwala, Sri Lanka."
                    keywords={`manage packages, sunflower beach resort packages, beruwala packages, ${baseKeywords}`}
                    url={`${baseUrl}/admin/packages`}
                  />
                  <AdminPackages />
                </>
              }
            />
            <Route
              path="/admin/gallery"
              element={
                <>
                  <SEO
                    title="Manage Gallery | Sun Flower Beach Resort, Beruwala"
                    description="Admin panel to manage gallery content for Sun Flower Beach Resort in Beruwala, Sri Lanka."
                    keywords={`manage gallery, sunflower beach resort gallery, beruwala gallery, ${baseKeywords}`}
                    url={`${baseUrl}/admin/gallery`}
                  />
                  <AdminGallery />
                </>
              }
            />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;